export class ValidationResult {

  // backgroundColor = 'transparent';
  backgroundColor = 0x1434;
  warning = false;
  error = false;
  messages = new Array<string>();
  applyStyle = true;


  public append(bean: ValidationResult): ValidationResult{
    if (bean.error){
      this.error = true;
    }else if (bean.warning){
      if (this.error===false){
        this.warning = true;
      }
    }
    if (this.applyStyle){
      this.applyStyle = bean.applyStyle;
    }
    this.messages.push(...bean.messages);
    return this;
  }

  public isSuccess(): boolean {
    let res = true;
    if (this.warning) {
      res = false;
    }
    if (this.error) {
      res = false;
    }
    // console.log('ValidationResult.isSuccess: ' + res);
    return res;
  }

  public style(): any {
    let val = 'transparent';
    let borderColor = null;
    let textColor = null;
    if (this.warning) {
      val = '#fe9b37'; // jaune Soleil
      //val = '#e76740'; // Orange Fiest
//      val = '#fecb37'; // jaune Soleil
//       textColor = 'white';
//       val = '#000000';
      textColor = '#ff9010';// jaune Soleil
    }else if (this.error) {
 //     val = '#ED1B32';
      val = '#EA3451';
      // textColor = 'white';
      textColor = val;
      borderColor = val;
    }
    if (!this.applyStyle){
      return {'background-color': 'transparent'};
    }

    if (textColor){
      // return {'background-color': val, 'color': textColor};
      return {'background-color': 'transparent', 'color': textColor, 'border-top': '3px solid ' + val };
    }else if (borderColor){
      return {'background-color': 'transparent', 'border-top': '3px solid ' + val };
    } else{
      return {'background-color': val};

    }
  }

}
